module.exports = __webpack_public_path__ + "img/erp_case10.eaee7322.png";